import { useContext, useEffect } from 'react';
import { Chat } from '../../../types/chat.types';
import { ChatSocketContextProps } from '../chatSocket.conext.types';
import { ChatSocketContext } from '../chatSocket.context';

interface UseChatSocketContextParams {
  selectedChat?: Chat;
}

export interface AccessibleChatSocketContextValues
  extends Omit<ChatSocketContextProps, 'connectToChatRoom' | 'disconnectFromChatRoom'> {}

export const useChatSocketContext = ({
  selectedChat,
}: UseChatSocketContextParams = {}): AccessibleChatSocketContextValues => {
  const { connectToChatRoom, disconnectFromChatRoom, ...accessibleChatSocketContextValues } =
    useContext<ChatSocketContextProps>(ChatSocketContext);

  useEffect(() => {
    if (!selectedChat || !selectedChat.id || !selectedChat.brand) {
      return;
    }

    connectToChatRoom({ brandId: selectedChat.brand.id, chatId: selectedChat.id });

    return () => {
      disconnectFromChatRoom({ brandId: selectedChat.brand.id, chatId: selectedChat.id });
    };
  }, [selectedChat?.id, accessibleChatSocketContextValues.errorRecoveringStateAfterDisconnect]);

  return accessibleChatSocketContextValues;
};
